import { useState } from "react";
import NewsCard from "../../../common/NewsCard";
import { Link } from "react-router-dom";

export default function News() {

    return (
        <div className="news">
            <div className="news__title">Uudised</div>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <div className="news__card" >
                    <NewsCard
                        image="../../../images/png/news-3.png"
                        imageAlt="News 3"
                        link="/article/et-EE/3/uudis-palmako-muutis-kutuse-hankimise-nahtavamaks-ja-paremini-juhitavaks"
                        title="UUDIS: Palmako muutis kütuse hankimise nähtavamaks ja paremini juhitavaks"
                        labels={[
                            "Puidutööstus",
                            "Reaalaja ülevaade",
                            "Varude juhtimine"
                        ]}
                        summary="Palmako viis koostöös Turgoiliga lõpule projekti,
                            mille eesmärk oli parandada ülevaadet ettevõtte kütusevarudest
                            ning vähendada töötajate koormust kütuse hankimise korraldamisel."
                    />
                </div>
                <div className="news__card" >
                    <NewsCard
                        image="../../../images/png/news-4.png"
                        imageAlt="News 4"
                        link="/article/et-EE/4/horizon-tselluloosi-ja-paberi-kogemus-automaatiseeritud-kutusehange-muudab-too-kiiremaks-ja-lihtsamaks"
                        title="Horizon Tselluloosi ja Paberi kogemus: automaatne kütusehange muudab töö kiiremaks ja lihtsamaks"
                        labels={[
                            "Tööstus",
                            "Automatiseerimine",
                            "Tarnekindlus"
                        ]}
                        summary="Horizoni Tselluloosi ja Paberi igapäevases tegevuses ja tööstusprotsesside
                            toimimises mängib kütus kriitilist rolli. Kuna iga tarneviivitus võib otseselt
                            mõjutada tootmise sujuvust, on tarnekindlus ettevõtte jaoks äärmiselt tähtis."
                    />
                </div>


            </div>
            <div style={{ display: 'flex', justifyContent: 'center', maxWidth: '860px', width: '100%', marginTop: '30px' }}>
                <Link to="/article/et-EE" style={{ textDecoration: 'none', width: '100%' }}>
                    <div className="news__empty">
                        Vaata veel uudiseid
                    </div>
                </Link>
            </div>
        </div>
    );
}
